<template>
    <fragment>
        <Layout background-color="#e3e9ea" hide-logout="true" :title="reportData.report.label" active="history"
                back-page-name="history" geName sub-title="History">
            <div v-if="reportData.report">
                <!-- Report First Part -->
                <div class="columns">
                    <div class="column">

                        <!-- Row1 -->
                        <div class="columns">
                            <div class="column">
                                <div class="block1-number">
                                    <div class="block1-number-conten nopadding">
                                        <div class="block1-number-label">
                                            Industry
                                        </div>
                                        <strong>
                                            {{reportData.report.industry.name}}
                                        </strong>
                                    </div>
                                </div>
                            </div>
                            <div class="column">
                                <div class="block1-number">
                                    <div class="block1-number-content nopadding">
                                        <div class="block1-number-label">
                                            Country
                                        </div>
                                        <strong>
                                           {{reportData.report.country.name}}
                                        </strong>
                                    </div>
                                </div>
                            </div>
                            <div class="column">
                                <div class="block1-number">
                                    <div class="block1-number-content nopadding">
                                        <div class="block1-number-label">
                                            Valuation Date
                                        </div>
                                        <strong>
                                            {{reportData.report.valuation_date| moment("YYYY-MM-DD")}}
                                        </strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- // Row1 -->



                    </div>
                </div>
                <!-- // Report First Part -->



                <!-- Statistics -->
                <div class="columns" style="position: relative">

                    <div class="column">
                        <div class="block1-chart">
                            <div class="block1-chart-title">
                                Valuation Ranges in {{reportData.report.country.name}}
                            </div>
                            <div class="block1-chart-body">
                                <world-range-graph :locked="false"
                                                   :data="reportData.country_range"></world-range-graph>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <div class="block1-chart">
                            <div class="block1-chart-title">
                                 Valuation ranges for the  {{reportData.report.industry.name}} industry
                            </div>
                            <div class="block1-chart-body">
                                <industry-range-graph :locked="false" :bar-width="35" color="#1EBCBE"
                                                      :data="reportData.industry_range"></industry-range-graph>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="block1-chart">
                            <div class="block1-chart-title">
                                 Corona Effect on the {{reportData.report.industry.name}} industry
                            </div>
                            <div class="block1-chart-body">
                                <industry-range-graph :locked="false" :bar-width="35" color="#158485"
                                                      :data="reportData.industry_range_corona"></industry-range-graph>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <div class="block1-chart">
                            <div class="block1-chart-title">
                              Valuation Ranges in {{reportData.report.country.name}}
                            </div>
                            <div class="block1-chart-body">
                                <country-range-graph :locked="false" :bar-width="35" color="#A5E4E5"
                                                     :data="reportData.country_range"></country-range-graph>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="block1-chart">
                            <div class="block1-chart-title">
                                Corona Effect on Valuation Ranges in {{reportData.report.country.name}}
                            </div>
                            <div class="block1-chart-body">
                                <country-range-graph :locked="false" :bar-width="35" color="#1EBCBE"
                                                     :data="reportData.country_range_corona"></country-range-graph>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- // Statistics -->
            </div>

        </Layout>
    </fragment>
</template>

<script>
    import {range} from "../../../shared/utils";
    import LeftInfoCol from "../components/LeftInfoCol";
    import FundUseGraph from "../../../shared/components/charts/FundUseGraph";
    import InvestmentPercentageGraph from "../../../shared/components/charts/InvestmentPercentageGraph";
    import ShareholdersGraph from "../../../shared/components/charts/ShareholdersGraph";
    import IndustryRangeGraph from "../../../shared/components/charts/IndustryRangeGraph";
    import CountryRangeGraph from "../../../shared/components/charts/CountryRangeGraph";
    import FourmethodsValuationGraph from "../../../shared/components/charts/FourmethodsValuationGraph";
    import RiskstepupGraph from "../../../shared/components/charts/RiskGraph";
    import ScorecardGraph from "../../../shared/components/charts/ScorecardGraph";
    import ChecklistGraph from "../../../shared/components/charts/ChecklistGraph";
    import {ReportAPI} from "../../../apis/ReportAPI";
    import Layout from "../../../shared/components/Layout";
    import WorldRangeGraph from "../../../shared/components/charts/WorldRangeGraph";
    import StageGraph from "../../../shared/components/charts/StageGraph";

    export default {
        name: 'report',
        components: {
            Layout,
            LeftInfoCol,
            ChecklistGraph,
            StageGraph,
            ScorecardGraph,
            RiskstepupGraph,
            FourmethodsValuationGraph,
            CountryRangeGraph,
            WorldRangeGraph,
            IndustryRangeGraph,
            ShareholdersGraph,
            InvestmentPercentageGraph,
            FundUseGraph
        },
        data() {
            return {
                scrollTop: 0,
                activeStep: 0,
                countryId: '',
                industryId: '',
                showResults: false,
                answers: {},
                reportData: {},
                results: {
                    industry: 'test',
                    country: 'UnitedStates',
                    stage: 'seed',
                    avg: '123',
                },
                completedSteps: {},
                year_range: (range(1980, new Date().getFullYear())).reverse()
            }
        },
        methods: {
            checkScrollTop(val) {
                return $(window).scrollTop() >= val;
            }
        },
        async mounted() {
            $(window).scroll(() => {
                let currentScroll = $(window).scrollTop();
                if (currentScroll > this.scrollTop) {
                    this.scrollTop = currentScroll;
                }
            });

            this.reportData = await ReportAPI.getLightReport(this.$route.params.id);
            SFAnalytics.track('Light Valuation Results Viewed', {
              reportId: this.$route.params.id,
            });
        },
        watch: {}
    }
</script>

<style scoped lang="scss">
    .white-block {
        background-color: #fff;
    }

    .unlock-charts {
        position: absolute;
        left: calc(50% - 122px);
        top: 70px;
        border-radius: 4px;
        text-align: center;
        background-color: #f3f3f366;
        padding: 20px;
        z-index: 99999;
        &.map {
            top: 200px;
        }
        .unlock-charts-icon {
            background-image: url("../../../images/icons/lock.svg");
            background-position: center;
            background-repeat: no-repeat;
            background-size: 25px;
            margin: auto;
            height: 48px;
            width: 48px;
            background-color: #FC4F26;
            border-radius: 50%;
        }
    }
</style>
